import React from 'react';
import { useRouter } from 'next/router';
import styles from '@components/position/jd/jd.module.scss';
import Title from '@components/position/jd/title';
import CompanyImage from '@components/position/jd/companyImage';
import CompanyInfo from '@components/position/jd/companyInfo';
import Contents from '@components/position/jd/contents';
import Welfare from '@components/position/jd/welfare';
import Map from '@components/position/jd/map';
import Apply from '@components/position/jd/apply';
import { useJDPreview } from '@repository/position/usePosition';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const PositionJDPreview = () => {
  const { query } = useRouter();
  const publicKey = query.publicKey as string;
  const positionId = query.positionId as string;

  const { data: positionDetail } = useJDPreview(publicKey, positionId);

  if (!positionDetail) return null;
  const {
    basicInfo: { externalYn },
  } = positionDetail;

  return (
    <div className={cx('wrap')}>
      {/* [D] 타이틀 영역 */}
      <Title positionDetail={positionDetail} />

      <div className={cx('inner')}>
        <div className={cx('infoArea')}>
          {/* [D] 회사 정보 영역 */}
          {!externalYn && <CompanyInfo positionDetail={positionDetail} />}

          {/* [D] ATS 에디터 영역 */}
          <Contents positionDetail={positionDetail} />

          {/* [D] 회사 이미지 영역 */}
          <CompanyImage positionDetail={positionDetail} />

          {/* [D] 복지 영역 */}
          <Welfare positionDetail={positionDetail} />

          {/* [D] 지도 영역 */}
          <Map positionDetail={positionDetail} />
        </div>

        {/* [D] 지원 영역 */}
        <Apply positionDetail={positionDetail} />
      </div>
    </div>
  );
};

export default PositionJDPreview;
